
import '../../frontend-js-dependencies-web/__liferay__/exports/cropperjs$dist$cropper.css.js';
